import React, { Component } from "react";
import keyCodes from "../../commonjs/keyCodes";
import keyListener from '../../commonjs/keyListener';
import $ from 'jquery';
import Store from '../../commonjs/store';
const remSize = 100;
let _Gitv = window.gitv;
export default class ScrollView extends Component {
   
    constructor(props) {
        super(props);
        this.state = {
            sTop:0,
            showMask: false,
        }
    }

    componentDidMount() {
        //初始化焦点
        keyListener.set(this.handleKeyDownKey, this.handleKeyUp);
    }

    thisY = 0
    scroll = 0;//模拟的滚动条
    handleKeyDownKey = (keyCode) => {
        //文档总高度
        let thisH = document.getElementById("scrollBox").clientHeight;
        //屏幕高度
        let content = document.getElementById("agreementList").clientHeight;
        //滚动槽高度
        const health_scroll = document.getElementById("health_scroll").clientHeight;
        //按向下键的次数
        const proportion = Math.ceil(thisH / 300);
        //计算出模拟滚动条和实际文本高度的比例，也就是按下键模拟滚动条每次向下滑动多少。
        const distancePerSliding =  Math.ceil(health_scroll / proportion);
        console.log(health_scroll)
        if (keyCode === keyCodes.up) {
            if (this.thisY >= content) {
                this.thisY = this.thisY - 300;
                this.scroll = this.scroll - distancePerSliding;
            } else {
                this.thisY = 0;
                this.scroll = 0;
            }
        } else if (keyCode === keyCodes.down) {

            if (this.thisY < thisH - content) {
                this.thisY = this.thisY + 300;
                this.scroll = this.scroll + distancePerSliding;
            } else if (this.thisY > thisH) {
                this.thisY = this.thisY;
            } else {
                //有margin所以要加上margin的距离
                this.scroll = health_scroll + 18;
            }
        }
        if (keyCode == keyCodes.down || keyCode === keyCodes.up) {
            $(".agreementList").scrollTop(this.thisY);
            this.setState({ sTop: this.scroll });
        } else if (keyCode == keyCodes.back) {
            _Gitv && _Gitv.onFinish ? _Gitv.onFinish() : '';
            console.log('exit----')
        }
    }


    componentWillUnmount() {
        // 组件销毁后，按键置空，归还上级
        keyListener.set(null);

    }

    render() {
        const { sTop } = this.state;
        const { data = {} } = this.props;
        const bjData = data.data || {}
        console.log(bjData.policyPageBgColor)
        return (
            <div className="scrollBox scrollBox_bj health_bj" style={{ background: bjData.policyPageBgColor || 'linear-gradient(180deg, #0E1625 0%, #112031 100%)'}}>
                <div id="agreementList" className={Store.getUrlParam("width") == 750?'agreementListPhone':'agreementList healethAgreementList'}>
                    { this.props.children }
                </div>
                <div className="health_scroll" id='health_scroll' style={{display:Store.getUrlParam("width") == 750?'none':'block'}}>
                    <div id='health_scrollbar' className="health_scrollbar" style={{marginTop:sTop / remSize + 'rem'}}></div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/agreement/ScrollView.js